import * as React from 'react';

import EndOperationContainer from 'modules/end-operation';
import EndOperationContent, { ERROR_TYPE } from '../error-page';
import { IEndOperationStoreProps } from 'modules/end-operation/end-operation.types';

const EndOperation = (props: IEndOperationStoreProps): JSX.Element => {
    return (
        <EndOperationContainer {...props}>
            <EndOperationContent type={ERROR_TYPE.END_OPERATION} />
        </EndOperationContainer>
    );
};

export default EndOperation;
